import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { DocumentsAllGetPayload } from 'Interfaces/Document';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload?: DocumentsAllGetPayload) =>
    $actions.document.getAllDocuments(dispatch, payload),
  );
};
